import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/auth/service';

/**
 * Blocks route when merchant-login permissions were issued
 * and the required `data.merchantPermission` key is missing.
 */
export const MerchantPermissionGuard: CanActivateFn = (route) => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);
  const requiredPermission = route.data?.['merchantPermission'] as
    | string
    | undefined;

  if (!requiredPermission) {
    return true;
  }

  if (!authService.canAccessMerchantPermission(requiredPermission)) {
    return router.createUrlTree(['/miscellaneous/error'], {
      queryParams: { code: 403 },
    });
  }

  return true;
};
